<template>
  <div class="d-flex justify-content-center quote-section">
    <span class="quote-text text-center">
      Ever seen an outfit you liked but couldn't work it into your wardrobe?
    </span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "~@/styles/_breakpoints.scss";
@import "~@/styles/_colour-palette.scss";

.quote-section {
  margin-top: 100px;
  margin-bottom: 100px;

  .quote-text {
    font-family: "Josefin Slab", serif;
    font-size: 2.2rem;
    font-weight: 400;
    font-style: italic;
    padding-left: 15px;
    padding-right: 15px;

    @include for-tablet-portrait-up {
      max-width: 80%;
    }

    @include for-tablet-landscape-up {
      max-width: 40%;
    }

    @include for-desktop-up {
      max-width: 25%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/QuoteSection.vue